import { styled } from '@mui/material';

export const CenterFlex = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const LoadingContainer = styled(CenterFlex)({
  width: '100%',
  height: '100vh',
});

export const Flex = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});
